import { Routes, Route, Outlet, Link } from "react-router-dom";

import Main from "./layouts/main"
import Home from "./pages/home"
import Contatti from "./pages/contatti"
import Esplora from "./pages/esplora"


export default function App() {
    return (
        <Routes>
             <Route path="/" element={<Main />}>

                <Route index element={<Home />} />
                <Route path="/ricerca" element={<Esplora />} />
                <Route path="/chi-siamo" element="" />
                <Route path="/contatti" element={<Contatti />} />

                <Route path="*" element={<NoMatch />} />

            </Route>
        </Routes>
    );
}



function NoMatch(){
    return (<>404</>);
}